export const actionTypes = {
  REQUEST_BEGIN: 'REQUEST_BEGIN',
  REQUEST_SUCCESS: 'REQUEST_SUCCESS',
  REQUEST_FAILURE: 'REQUEST_FAILURE',
};
